import { render, staticRenderFns } from "./WTextarea.vue?vue&type=template&id=2345ad8a&scoped=true&lang=pug&"
import script from "./WTextarea.vue?vue&type=script&lang=js&"
export * from "./WTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2345ad8a",
  null
  
)

export default component.exports